import React from 'react';
import { ReactComponent as VestibularDigitalIconNew } from 'assets/img/VestibularDigitalIconNew.svg';
import * as S from './style';

function HeaderLogin() {
  return (
    <S.LinkContainerStyled
      href="https://lp.fundacred.org.br/simuladodigital"
      target="blank"
    >
      <VestibularDigitalIconNew width={20} height={20} />
      <span>Simulado Digital</span>
    </S.LinkContainerStyled>
  );
}

export default HeaderLogin;
